var wrapperStyle = "\n    position: fixed;\n    bottom: 100%; \n    left: 0; \n    backgroud: red; \n    width: 50px; \n    height: 50px; \n    overflow: auto;\n";
function getter() {
    var wrapper = document.querySelector('.scrollbar-getter');
    var inner = document.querySelector('.scrollbar-getter-inner');
    if (!wrapper || !inner) {
        wrapper = document.createElement('div');
        wrapper.classList.add('scrollbar-getter');
        wrapper.style.cssText = wrapperStyle;
        inner = document.createElement('div');
        inner.classList.add('scrollbar-getter-inner');
        inner.style.cssText = 'width: 100%; height: 60px;';
        wrapper.appendChild(inner);
        document.body.appendChild(wrapper);
    }
    return wrapper.offsetWidth - inner.offsetWidth;
}
var getScrollbarWidth = (function () {
    var size = null;
    return function () {
        if (!size) {
            size = getter();
            return size;
        }
        return size;
    };
})();
export default getScrollbarWidth;
//# sourceMappingURL=getScrollbarWidth.js.map